<h2 mat-dialog-title mat-dialog-draggable-title>{{'title.add_staff' | translate}}
  <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="onNoClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<form name="form" #f="ngForm" (ngSubmit)="!f.form.valid? accordion.openAll() : 'true' && f.form.valid && onCreateUser()"
  [appCheckPhone]="['phone']" [appCheckUserName]="['userName']" [appCheckUserNamePrefix]="[usernamePrefix]"
  appFocusFirstElement>
  <mat-dialog-content>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <!-- Thông tin người dùng -->
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header class="pt-2">
          <mat-panel-title class="mat-panel-title justify-content-between">
            <span>{{'title.staff_info' | translate}}</span>
            <small class="form-text text-gray">(<span style="color: red;">*</span>) {{'form.info' | translate}}</small>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="row">
          <!-- Nhập email -->
          <div class="col-sm-6">
            <mat-form-field class="mat-full-width">
              <mat-label>{{'form.email' | translate}}</mat-label>
              <input (focusout)="user.email = user.email.trim()" #focusInput autocomplete="off" id="email" matInput
                [placeholder]="'placeholder.email' | translate" type="text" name="email" [(ngModel)]="user.email"
                #email="ngModel" [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" required
                [pattern]="emailPattern" [maxlength]="emailMaxlength" />
              <button mat-button *ngIf="user.email" type="button" matSuffix mat-icon-button aria-label="Clear"
                (click)="user.email=''">
                <mat-icon>close</mat-icon>
              </button>
              <mat-error *ngIf="f.submitted || email.invalid">
                <span class="text-error" *ngIf="email?.errors?.required">
                  {{'validation.email' | translate}}
                </span>
                <span class="text-error" *ngIf="email?.errors?.pattern">
                  {{'validation.email_format' | translate}}
                </span>
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Tên đăng nhập -->
          <div class="col-sm-6">
            <mat-form-field class="mat-full-width">
              <input (focusout)="user.userName = user.userName.trim()" autocomplete="off" id="userName" matInput
                [placeholder]="'form.username1' | translate" type="text" name="userName" [(ngModel)]="user.userName"
                #userName="ngModel" #usernameRef maxlength="200" />
              <button mat-button *ngIf="user.userName" type="button" matSuffix mat-icon-button aria-label="Clear"
                (click)="user.userName=''">
                <mat-icon>close</mat-icon>
              </button>
              <mat-error *ngIf="f.submitted || userName.invalid">
                <span class="text-error" *ngIf="userName?.errors?.invalidRequired">
                  {{'validation.username' | translate}}
                </span>
                <span class="text-error" *ngIf="userName?.errors?.validIp">
                  {{'validation.username_format1' | translate}}
                </span>
                <span class="text-error" *ngIf="userName?.errors?.duplicate">
                  {{'validation.err_user_name_duplicate' | translate}}
                </span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <!-- Họ và tên -->
          <div class="col-sm-6">
            <mat-form-field class="mat-full-width">
              <input (focusout)="user.fullName = user.fullName.trim()" autocomplete="off" id="fullName" matInput
                [placeholder]="'form.fullname' | translate" type="text" name="fullName" [(ngModel)]="user.fullName"
                #fullName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && fullName.invalid }" required
                maxlength="200" />
              <button mat-button *ngIf="user.fullName" type="button" matSuffix mat-icon-button aria-label="Clear"
                (click)="user.fullName=''">
                <mat-icon>close</mat-icon>
              </button>
              <mat-error *ngIf="f.submitted || fullName.invalid">
                <span class="text-error" *ngIf="fullName?.errors?.required">
                  {{'validation.full_name' | translate}}
                </span>
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Loại người dùng -->
          <!-- <div class="col-sm-6">
            <mat-form-field class="mat-full-width">
              <mat-label>{{'form.user_type' | translate}}</mat-label>
              <mat-select #userTypeSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                (focus)="commonService.openComboBox(checkFocus, userTypeSelect)" id="userType" name="userType"
                [(ngModel)]="user.userType">
                <mat-option value="2" (click)="this.commonService.closeDropdownList(this.userTypeSelect)">
                  {{'form.user' | translate}}</mat-option>
                <mat-option value="1" (click)="this.commonService.closeDropdownList(this.userTypeSelect)">
                  {{'form.admin' | translate}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div> -->
          <div class="col-sm-6" *ngIf="!isUserTypeRestricted">
            <mat-label style="color: #858796">{{'form.user_type' | translate}}</mat-label><br>
            <mat-radio-group #userTypeSelect id="userType" name="userType" [(ngModel)]="user.userType">
              <mat-radio-button value="2" class="pt-2 mr-3">{{'form.user' | translate}}</mat-radio-button>
              <mat-radio-button value="1">{{'form.admin' | translate}}</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="col-sm-6" *ngIf="isUserTypeRestricted">
            <mat-label style="color: #858796">{{'form.user_type' | translate}}</mat-label><br>
            <mat-radio-group #userTypeSelect id="userType" name="userType" [(ngModel)]="user.userType">
              <mat-radio-button value="2" class="pt-2 mr-3" [checked]="true">{{'form.user' | translate}}</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="row">
          

          <!-- Số điện thoại-->
          <div class="col-sm-6">
            <mat-form-field class="mat-full-width">
              <mat-label>{{'form.phone' | translate}}</mat-label>
              <input (focusout)="user.phone = user.phone.trim()" autocomplete="off" type="text" matInput
                [placeholder]="'placeholder.phone' | translate" name="phoneNumber" id="phoneNumber" [(ngModel)]="user.phone"
                #phoneNumber="ngModel" [ngClass]="{ 'is-invalid': f.submitted && phoneNumber.invalid }" [pattern]="phonePattern2" [maxlength]="phoneMaxlength" required/>
              <button mat-button *ngIf="user.phone" type="button" matSuffix mat-icon-button aria-label="Clear"
                (click)="user.phone=''">
                <mat-icon>close</mat-icon>
              </button>
              <mat-error *ngIf="f.submitted || phoneNumber.invalid">
                <span class="text-error" *ngIf="phoneNumber?.errors?.required">
                  {{'validation.phone' | translate}}
                </span>
                <span class="text-error" *ngIf="phoneNumber?.errors?.pattern">
                  {{'validation.phone_format_upgrade' | translate}}
                </span>
              </mat-error>
            </mat-form-field>
          </div>
          <!-- checkbox -->
          <div class="col-md-6 pt-4">
            <mat-checkbox [(ngModel)]="user.isSmsSend" name="isSmsSend">
              <span style="font-size:14px;" >{{'search_form.send_info_sms' |translate}}</span>
            </mat-checkbox>
          </div>
        </div>
        <div class="row">
          <!-- Loại giấy tờ -->
          <div class="col-sm-6">
            <mat-form-field class="mat-full-width">
              <mat-label>
                {{'form.type_certification' | translate}}
              </mat-label>
              <mat-select #certificateSelect (selectionChange)="checkFocus = false"
              (focus)="commonService.openComboBox(checkFocus, certificateSelect)" id="certificateId" name="certificateId"
              [(ngModel)]="user.certificateId">
              <input (keydown)="$event.stopPropagation()" type="text"  matInput placeholder="{{'search_form.search' | translate}}"
               style="padding-left: 15px;height: 48px;color: #000000;" (input)="onInputCertificateChange($event)"/>
              <mat-divider></mat-divider>
              <mat-option  (click)="this.commonService.closeDropdownList(this.certificateSelect)" [value]="item.id" *ngFor="let item of listCertificateFilter">{{item.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- Số giấy tờ -->
          <div class="col-sm-6">
            <mat-form-field class="w-100">
              <input (focusout)="user.certificateNo=user.certificateNo.trim()" matInput
                [placeholder]="'form.certification_no' | translate" type="text" name="certificateNo1"
                id="certificateNo1" [(ngModel)]="user.certificateNo" #certificateNo1="ngModel"
                maxlength="20" [pattern]="certificateNoPattern"
              />
              <button mat-button *ngIf="user.certificateNo" type="button" matSuffix
                mat-icon-button aria-label="Clear" (click)="clearCerNo()">
                <mat-icon>close</mat-icon>
              </button>
              <mat-error *ngIf="certificateNo1?.errors?.pattern">
                {{'validation.gpkd_format' | translate}}
              </mat-error>
              <mat-error *ngIf="certificateNo1?.errors?.duplicate">
                {{ 'validation.err_cust_certificate_no_duplicate' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row">

          <!-- Phòng ban -->
          <!-- <div class="col-sm-6">
            <mat-form-field class="w-100">
              <mat-label>{{'form.department' | translate}}</mat-label>
              <mat-select #serviceTypeSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                (focus)="commonService.openComboBox(checkFocus, serviceTypeSelect)" id="serviceType" name="serviceType" [(ngModel)]="documents.serviceType"
                >
                <mat-option>
                  <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                    [placeholderLabel]="'search_form.search' | translate" [formControl]="serviceTypesFilterCtrl">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option value="null" selected>
                  {{'form.select_all' | translate}}
                </mat-option> -->
                 <!-- <mat-option>
                *ngFor="let serviceType of filteredServiceTypes | async" [value]="serviceType.id"
                  (click)="this.commonService.closeDropdownList(this.serviceTypeSelect)"
                  > -->
                  <!-- {{serviceType.name}}
                </mat-option> -->
              <!-- </mat-select>
            </mat-form-field>
          </div> -->

          <!-- Công ty/Chi nhánh -->
          <div class="col-sm-6">
            <ng-mat-autocomplete validation="true" [validationError]="'validation.company_branch_required' | translate"
              [placeholder]="'form.branch1' | translate" [source]="parentBranches" [minChars]="0"
              [displayItem]="'item.name'" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedBranch"
              (ngModelChange)="onChangeAutoCompleted()" [hasProgressBar]="true" [isFocused]="false">
            </ng-mat-autocomplete>
            <input (focusout)="user.enterpriseId = user.enterpriseId.trim()" autocomplete="off" type="hidden"
              class="form-control" name="enterpriseId" [(ngModel)]="user.enterpriseId" #enterpriseId="ngModel"
              [ngClass]="{ 'is-invalid': f.submitted && enterpriseId.invalid }" required />
          </div>

          <!-- Mô tả-->
          <div class="col-sm-6">
            <mat-form-field class="mat-full-width">
              <textarea (focusout)="user.description = user.description.trim()" style="overflow:hidden" type="text"
                matInput [matTextareaAutosize] [placeholder]="'headertable.description' | translate" name="description"
                id="description" [(ngModel)]="user.description" maxlength="500"></textarea>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <!-- Phòng ban-->
          <div class="col-sm-6">
            <mat-form-field class="mat-full-width">
              <mat-label>
                {{'form.department' | translate}}
              </mat-label>
              <mat-select #statusSelect (selectionChange)="checkFocus = false"
              (focus)="commonService.openComboBox(checkFocus, statusSelect)" id="status" name="status"
              [(ngModel)]="user.departmentId" >
              <input (keydown)="$event.stopPropagation()" type="text"  matInput placeholder="{{'alert.search_department_name_placeholder' | translate}}"
               style="padding-left: 15px;height: 48px;color: #000000;" (input)="onInputChange($event)" maxlength="200"/>
              <mat-divider></mat-divider>
                <mat-option [value]="null">
                  {{'form.department_choice' | translate}}</mat-option>
                  <mat-option  (click)="this.commonService.closeDropdownList(this.statusSelect)" [ngStyle]="{'display': item.isDeleted ? 'none' : null}" [value]="item.id" *ngFor="let item of listDepartment">{{item.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Chức danh -->
          <div class="col-sm-6">
            <mat-form-field class="mat-full-width">
              <input (focusout)="user.userPosition=user.userPosition.trim()" matInput
                [placeholder]="'form.userPosition' | translate" type="text" name="userPosition"
                id="userPosition" [(ngModel)]="user.userPosition" #userPosition="ngModel"
                maxlength="255"
              />
              <button mat-button *ngIf="user.userPosition" type="button" matSuffix
                mat-icon-button aria-label="Clear" (click)="user.userPosition = ''">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <!--ngày sinh-->
          <div class="col-sm-6">
            <mat-form-field class="mat-full-width">
              <input matInput [placeholder]="'form.birthday' | translate" autocomplete="off" [max]="maxDate"
                (change)="this.commonService.resetDatePicker(pickerInput2.value, this.ngForm.controls['birthday'])"
                (dateInput)="addEvent($event)" (dateChange)="addEvent($event)" [matDatepicker]="birthday1"
                name="birthday" [(ngModel)]="user.birthday" maxlength="10" #birthday2="ngModel" #pickerInput2 />
              <mat-datepicker-toggle matSuffix [for]="birthday1">
                <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                  [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
              </mat-datepicker-toggle>
              <mat-datepicker #birthday1></mat-datepicker>
              <mat-error *ngIf="f.submitted || birthday2.invalid">
                {{getErrorDateMessage(pickerInput2.value)}}
              </mat-error>
            </mat-form-field>
          </div>
          <!-- Thời gian cấp cccd  -->
          <div class="col-sm-6">
            <mat-form-field class="mat-full-width">
              <input matInput [placeholder]="'form.idIssueDate' | translate" autocomplete="off" [max]="maxDate"
                (change)="this.commonService.resetDatePicker(pickerInput3.value, this.ngForm.controls['idIssueDate'])"
                (dateInput)="addEvent($event)" (dateChange)="addEvent($event)" [matDatepicker]="idIssueDate1"
                name="idIssueDate" [(ngModel)]="user.idIssueDate" maxlength="10" #idIssueDate2="ngModel" #pickerInput3 />
              <mat-datepicker-toggle matSuffix [for]="idIssueDate1">
                <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                  [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
              </mat-datepicker-toggle>
              <mat-datepicker #idIssueDate1></mat-datepicker>
              <mat-error *ngIf="f.submitted || idIssueDate2.invalid">
                {{getErrorDateMessage(pickerInput3.value)}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <!-- Nơi cấp CCCD/Số định danh  -->
          <div class="col-sm-6">
            <mat-form-field class="mat-full-width">
              <input (focusout)="user.idIssuePlace=user.idIssuePlace.trim()" matInput
                [placeholder]="'form.idIssuePlace' | translate" type="text" name="idIssuePlace"
                id="idIssuePlace" [(ngModel)]="user.idIssuePlace" #idIssuePlace="ngModel"
                maxlength="255"
              />
              <button mat-button *ngIf="user.idIssuePlace" type="button" matSuffix
                mat-icon-button aria-label="Clear" (click)="user.idIssuePlace = ''">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <!-- Quốc tịch  -->
          <div class="col-sm-6">
            <mat-form-field class="mat-full-width">
              <input (focusout)="user.nationality=user.nationality.trim()" matInput
                [placeholder]="'form.nationality' | translate" type="text" name="nationality"
                id="nationality" [(ngModel)]="user.nationality" #nationality="ngModel"
                maxlength="255"
              />
              <button mat-button *ngIf="user.nationality" type="button" matSuffix
                mat-icon-button aria-label="Clear" (click)="user.nationality = ''">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <!-- Nơi thường trú  -->
          <div class="col-sm-6">
            <mat-form-field class="mat-full-width">
              <input (focusout)="user.address=user.address.trim()" matInput
                [placeholder]="'form.address_current' | translate" type="text" name="address"
                id="address" [(ngModel)]="user.address" #address="ngModel"
                maxlength="255"
              />
              <button mat-button *ngIf="user.address" type="button" matSuffix
                mat-icon-button aria-label="Clear" (click)="user.address = ''">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <!-- Nơi ở hiện tại   -->
          <div class="col-sm-6">
            <mat-form-field class="mat-full-width">
              <input (focusout)="user.livingAddress=user.livingAddress.trim()" matInput
                [placeholder]="'form.livingAddress' | translate" type="text" name="livingAddress"
                id="livingAddress" [(ngModel)]="user.livingAddress" #livingAddress="ngModel"
                maxlength="255"
              />
              <button mat-button *ngIf="user.livingAddress" type="button" matSuffix
                mat-icon-button aria-label="Clear" (click)="user.livingAddress = ''">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </div>

      </mat-expansion-panel>

      <!-- Phân quyền -->
      <mat-expansion-panel class="mb-3" *ngIf="user.userType && user.userType == '2'">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'form.auth' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form #fd="ngForm">
          <div class="row">
            <div class="col-12 col-md-6">
              <label class="col-form-label font-weight-bold">{{'form.all_auth' | translate}}</label>
              <mat-form-field class="mat-full-width">
                <input type="text" autocomplete="off" matInput name="groupPermissions" [(ngModel)]="filterWords"
                  (focusout)="filterWords=filterWords.trim()" (ngModelChange)="onFilterFeatures()"
                  [placeholder]="'placeholder.search_user_group' | translate" />
                <button mat-button *ngIf="filterWords" type="button" matSuffix mat-icon-button aria-label="Clear"
                  (click)="filterWords=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="col-12 col-md-6">
              <label class="col-form-label font-weight-bold text-left">{{'form.select_auth' |
                translate}}</label>
              <mat-form-field class="mat-full-width">
                <input type="text" autocomplete="off" matInput name="groupPermissions" [(ngModel)]="filterWordsSelected"
                  (focusout)="filterWordsSelected=filterWordsSelected.trim()"
                  (ngModelChange)="onFilterFeaturesSelected()"
                  [placeholder]="'placeholder.search_user_group' | translate" />
                <button mat-button *ngIf="filterWordsSelected" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="filterWordsSelected=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-5">
              
            </div>
            <div class="col-5 offset-2">
              
            </div>
          </div> -->
          <div class="row mt-1">
            <div class="col-md-5 pr-075">
              <div class="card vt-list-role">
                <div class="card-body">
                  <div tabindex="0" id="myLeftTab{{i}}"
                    (keyup.arrowdown)="this.commonService.downArrow(i,'myLeftTab', this.dataList)"
                    (keyup.arrowup)="this.commonService.upArrow(i,'myLeftTab', this.dataList)"
                    (keyup.enter)="this.commonService.moveEvent(i,'myLeftTab', 'moveLeft')"
                    *ngFor="let data of dataList; let i = index" (click)="getIndex(data)" class="list mt-1 p-1"
                    [ngClass]="{ 'list': this.leftList.indexOf(data) >= 0 }">
                    {{ data.name }}
                  </div>
                </div>
              </div>                                                                                                                                                                                              
            </div>
            <div class="col-md-2 text-center pr-075">
              <div>
                <div class="mt-2 stroked-button">
                  <div id="moveLeft" class="angle-button {{this.leftList.length == 0 ? 'disable' : ''}}" (click)="moveClick()">
                    <i class="fa fa-angle-right fa-lg" aria-hidden="true"></i>
                  </div>
                </div>
                <div class="mt-2 stroked-button">
                  <div class="angle-button" (click)="moveAllClick()">
                    <i class="fa fa-angle-double-right fa-lg" aria-hidden="true"></i>
                  </div>
                </div>
                <div class="mt-2 stroked-button">
                  <div id="moveRight" class="angle-button {{this.rightList.length == 0 ? 'disable' : ''}}" (click)="returnClick()">
                    <i class="fa fa-angle-left fa-lg" aria-hidden="true"></i>
                  </div>
                </div>
                <div class="mt-2 stroked-button">
                  <div class="angle-button" (click)="returnAllClick()">
                    <i class="fa fa-angle-double-left fa-lg" aria-hidden="true"></i>
                  </div>
                </div>
                <!-- <div class="mt-2">
                  <button id="moveLeft" mat-stroked-button color="primary"
                    class="mat-stroked-button-custom-decentralization" (click)="moveClick()" type="button"
                    [disabled]="this.leftList.length == 0">
                    <mat-icon>chevron_right</mat-icon>
                  </button>
                </div>
                <div class="mt-2">
                  <button mat-stroked-button color="primary" class="mat-stroked-button-custom-decentralization"
                    (click)="moveAllClick()" type="button">
                    <mat-icon aria-hidden="true">last_page</mat-icon>
                  </button>
                </div>
                <div class="mt-2">
                  <button id="moveRight" mat-stroked-button class="mat-stroked-button-custom-decentralization"
                    type="button" color="primary" (click)="returnClick()" [disabled]="this.rightList.length == 0">
                    <mat-icon>chevron_left</mat-icon>
                  </button>
                </div>
                <div class="mt-2 mb-2">
                  <button mat-stroked-button type="button" class="mat-stroked-button-custom-decentralization"
                    color="primary" (click)="returnAllClick()">
                    <mat-icon aria-hidden="true">first_page</mat-icon>
                  </button>
                </div> -->
              </div>
            </div>
            <div class="col-md-5 pr-075">
              <div class="card vt-list-role">
                <div class="card-body">
                  <div tabindex="0" id="myRightTab{{i}}"
                    (keyup.arrowdown)="this.commonService.downArrow(i,'myRightTab', this.selectedList)"
                    (keyup.arrowup)="this.commonService.upArrow(i,'myRightTab', this.selectedList)"
                    (keyup.enter)="this.commonService.moveEvent(i,'myRightTab','moveRight')"
                    *ngFor="let data of selectedList; let i = index" (click)="getReturnIndex(data)"
                    class="list mt-1 p-1" [ngClass]="{'list': this.rightList.indexOf(data) >= 0}">
                    {{ data.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </mat-expansion-panel>

    </mat-accordion>
  </mat-dialog-content>
  <mat-divider></mat-divider>
  <mat-dialog-actions align="left">
    <mat-checkbox color="primary" name="isMultiCreateUser" (change)="isMultiCreateUser = !isMultiCreateUser">
      {{'form.allow_create_multi_user' | translate}}
    </mat-checkbox>
  </mat-dialog-actions>
  <mat-dialog-actions align="center">
    <button mat-stroked-button color="primary" class="mr-3" (click)="onNoClick()" type="button">
      <mat-icon class="mr-0">cancel</mat-icon>
      {{'button.cancel' | translate}}
    </button>
    <button mat-raised-button [disabled]="!isFormChanging" type="submit" color="primary" cdkFocusInitial
      (click)="onClickBtnSubmit()">
      <mat-icon class="mr-0">save</mat-icon>
      {{'button.add_user' | translate}}
    </button>
  </mat-dialog-actions>
</form>
